export class Constants {
    //public static weburl = "http://localhost:3000";
    //public static apiurl = "https://localhost:7054";
    // public static clientId = '25bd6e81-6c26-4c4b-91c5-e7ecb40f836d';
    // public static authority = 'https://sportsadmin.b2clogin.com/sportsadmin.onmicrosoft.com/B2C_1_susi';
    public static redirectUri = 'http://localhost:3000';

    public static weburl = "http://www.inpistaconilcuore.it";
    public static apiurl = "https://auctionsapi-azcyhef8c4cqh3cg.westeurope-01.azurewebsites.net";
    public static clientId = '25bd6e81-6c26-4c4b-91c5-e7ecb40f836d';
    public static authority = 'https://sportsadmin.b2clogin.com/sportsadmin.onmicrosoft.com/B2C_1_auctions_susi';
    //public static redirectUri = 'https://auctions-fybfcddud5fed9ht.westeurope-01.azurewebsites.net';

    public static knownAuthorities = ["sportsadmin.b2clogin.com"];
    public static scopes = [
        'https://sportsadmin.onmicrosoft.com/968a3e73-19a8-4fca-a27c-8a8a05f34c77/auctions.read'
    ]
}